import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import authReducer from "./authReducer";
import userReducer from "./userReducer";
import companyUserReducer from "./companyUserReducer";
import contaReducer from "./contaReducer";
import companyReducer from "./companyReducer";
import addressReducer from "./addressReducer";
import contractReducer from "./contractReducer";
import reportReducer from "./reportReducer";
import orderServicesReducer from "./orderServicesReducer";
import segmentTypeReducer from "./segmentTypeReducer";
import serviceTypeReducer from "./serviceTypeReducer";
import equipmentTypeReducer from "./equipmentTypeReducer";
import fileReducer from "./fileReducer";

export default combineReducers({
  form: formReducer,
  auth: authReducer,
  users: userReducer,
  companyUsers: companyUserReducer,
  contas: contaReducer,
  companies: companyReducer,
  address: addressReducer,
  contracts: contractReducer,
  reports: reportReducer,
  orderServices: orderServicesReducer,
  segment_types: segmentTypeReducer,
  service_types: serviceTypeReducer,
  equipment_types: equipmentTypeReducer,
  file: fileReducer,
});
